import React from 'react';
import Team from '../components/Team';

const TeamPage = () => {
  return <Team />;
};

export default TeamPage;
